import React, { useState, useContext, useEffect } from "react";
import axios from "../../../../axios/index";

import { UserContext } from "../../../Context/UserContextProvider";

import ImageUploading from "react-images-uploading";
import { Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AddImg1 from "./AddImg1";
import AddImg2 from "./AddImg2";

// Styles
import styles from "./../Settings.module.css";
import Dstyles from "../../DashboardFileManagement/DashboardFileManagement.module.css";

// Image
import noProfileAboutIcon from "./../../../../assets/img/DashboardICons/noProfileAboutIcon.svg";
import addIconBlue from "./../../../../assets/img/DashboardICons/AddIconBlue.svg";
import trashIcon from "./../../../../assets/img/DashboardICons/TrashIcon.svg";

const SettingAboutForm = props => {
  const { userToken } = useContext(UserContext);
  const [images, setImages] = useState({
    image1: [],
    image2: [],
  });
  // console.log(images)
  const [btnLoader, setBtnLoader] = useState(false);
  const [btnLoader2, setBtnLoader2] = useState(false);
  const [formAboutValue, setFormAboutValue] = useState({
    title_1: "",
    content_1: "",
    title_2: "",
    content_2: "",
    image1: [],
    image2: [],
    isLoading: true,
    teams: [
      {
        id: 0,
        userProfile: [],
        fullName: "",
        position: "",
      },
    ],
  });

  const [teamData, setTeamData] = useState([]);

  useEffect(() => {
    const getData = async () => {
      const getTeamData = await axios.get("AboutUs/GetTeamUsers");
      const getAboutData = await axios.get("AboutUs/GetAboutUsData");
      const aboutData = await getAboutData.data.data;

      setFormAboutValue(prev => {
        return {
          ...prev,
          title_1: aboutData.firstTitle,
          content_1: aboutData.firstDescription,
          content_2: aboutData.secondDescription,
          title_2: aboutData.secondTitle,
          image1Chnaged: true,
          image2Chnaged: true,
          isLoading: false,
          image1: aboutData.firstImageName,
          image2: aboutData.secondImageName,
        };
      });
      setTeamData(getTeamData.data.data);
    };
    getData();
  }, []);

  // Change Value Forms About (Titles And Contents)
  const formAboutChangeHandler = (e, id) => {
    setFormAboutValue({
      ...formAboutValue,
      [e.target.name]: e.target.value,
    });
  };

  // Upload Image Profile Persons Team
  const changeImageAboutHandler = (imageAbout, id) => {
    let newImageTeams = formAboutValue.teams.map(team => {
      if (team.id === id) return { ...team, userProfile: imageAbout };
      return team;
    });

    setFormAboutValue({
      ...formAboutValue,
      teams: newImageTeams,
    });
  };

  // Change Value Forms About (Teams)
  const formAboutTeamChangeHandler = (e, id) => {
    let newTeams = formAboutValue.teams.map(team => {
      if (team.id === id) return { ...team, [e.target.name]: e.target.value };
      return team;
    });

    setFormAboutValue({
      ...formAboutValue,
      teams: newTeams,
    });
  };

  const addTeamPersonHandler = () => {
    setFormAboutValue({
      ...formAboutValue,
      teams: [
        ...formAboutValue.teams,
        {
          id: formAboutValue.teams.length,
          userProfile: [],
          fullName: "",
          position: "",
        },
      ],
    });
  };

  return (
    <>
      {formAboutValue.isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div dir="rtl" className={`text-right mx-4 px-2 mt-4 mb-3`}>
          <ToastContainer
            position="top-right"
            autoClose={8000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover={false}
            theme="light"
          />

          {/* About Form 1 */}
          <div className={`d-flex justify-content-between align-items-start flex-wrap mt-2 py-2`}>
            <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
              <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="title_1">
                {" "}
                عنوان اول{" "}
              </Form.Label>
              <Form.Control
                className={`${styles.form_control_input} shadow-none`}
                type="text"
                id="title_1"
                name="title_1"
                value={formAboutValue.title_1}
                onChange={formAboutChangeHandler}
              />
            </Form.Group>
            <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column w-100`}>
              <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="content_1">
                {" "}
                متن عنوان اول{" "}
              </Form.Label>
              <Form.Control
                style={{ resize: "none" }}
                className={`${styles.form_control_input} shadow-none`}
                as="textarea"
                rows={10}
                id="content_1"
                name="content_1"
                value={formAboutValue.content_1}
                onChange={formAboutChangeHandler}
              />
            </Form.Group>
          </div>

          <div className="container py-3 w-100 d-flex flex-column align-items-start justify-content-center mb-4">
            <h4 className={`mb-4 ${styles.text1}`}>افزودن عکس</h4>
            <AddImg1 formAboutValue={formAboutValue} setFormAboutValue={setFormAboutValue} images={images.image1} setImages={setImages} />
          </div>

          {/* About Form 2 */}
          <div className={`d-flex justify-content-between align-items-start flex-wrap mb-2 py-3`}>
            <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
              <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="title_2">
                {" "}
                عنوان دوم{" "}
              </Form.Label>
              <Form.Control
                className={`${styles.form_control_input} shadow-none`}
                type="text"
                id="title_2"
                name="title_2"
                value={formAboutValue.title_2}
                onChange={formAboutChangeHandler}
              />
            </Form.Group>
            <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column w-100`}>
              <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="content_2">
                {" "}
                متن عنوان دوم{" "}
              </Form.Label>
              <Form.Control
                style={{ resize: "none" }}
                className={`${styles.form_control_input} shadow-none`}
                as="textarea"
                rows={10}
                id="content_2"
                name="content_2"
                value={formAboutValue.content_2}
                onChange={formAboutChangeHandler}
              />
            </Form.Group>
          </div>

          <div className="container py-3 w-100 d-flex flex-column align-items-start justify-content-center mb-4">
            <h4 className={`mb-4 ${styles.text1}`}>افزودن عکس</h4>
            <AddImg2 formAboutValue={formAboutValue} setFormAboutValue={setFormAboutValue} images={images.image2} setImages={setImages} />
          </div>

          <div className="py-2 mb-4">
            <div className="container-fluid">
              <div
                className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                dir="rtl">
                <div className="w-100 d-flex align-items-center justify-content-md-end justify-content-center">
                  {btnLoader2 ? (
                    <div className={Dstyles.btn_loader_container}>
                      <div className={Dstyles.btn_spinner}></div>
                    </div>
                  ) : (
                    <button className={`${Dstyles.filled_blue} text-white border-0`} onClick={formSendHandler}>
                      {" "}
                      ثبت اطلاعات دفتر{" "}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* team members */}
          <div className="container py-3 w-100 d-flex flex-column align-items-start justify-content-center mb-4">
            <h4 className={`mb-4 ${styles.text1}`}>افزودن عکس</h4>
            <div className="w-100 position-relative d-flex align-items-center justify-content-md-between justify-content-center flex-wrap my-4">
              {teamData?.map(item => (
                <div key={item.id} className="d-flex flex-column align-items-center justify-content-center my-2 mx-md-2 mx-3">
                  <div className="position-relative">
                    <img
                      className={styles.team_member_img}
                      src={`https://backdev.azrmelk.com/images/TeamUserImages/${item.imageName}`}
                      loading="lazy"
                      alt="team_member_img"
                    />
                    <div className={`d-flex align-items-center justify-content-center ${styles.remove_img_container}`}>
                      <img onClick={() => memberDeleteHandler(item.id)} src={trashIcon} alt="icon" />
                      {/* onClick={() => memberDeleteHandler(item.id)}  */}
                    </div>
                  </div>

                  <div className="d-flex flex-column align-items-center justify-content-center mt-3">
                    <div className={`mb-2 ${styles.member_title}`}>{item.fullName}</div>
                    <div className={styles.member_duty}>{item.responsibility}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* team members */}

          {/* Our Team Forms */}
          <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-2" dir="rtl">
            <div className={`d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2 ${styles.title_teams_box}`}>تیم ما</div>

            <div className="d-flex align-items-center justify-content-end flex-wrap mt-2 mb-2" role="button" onClick={addTeamPersonHandler}>
              <img className="ms-2 ps-1" src={addIconBlue} alt="setting-icon" />
              <div className={styles.link_icon_text}>افزودن نفر</div>
            </div>
          </div>

          <div className={`mb-4`}>
            {formAboutValue.teams.map(team => (
              <div key={team.id} className={`w-100 d-flex justify-content-between align-items-center py-3 ${styles.total_team_forms_box}`}>
                <div
                  style={{ border: team.userProfile.length <= 0 ? "1px dashed #E3E3E3" : "none" }}
                  className={`position-relative my-2 d-flex justify-content-center align-items-center flex-column ${styles.total_upload_image_about_box}`}>
                  <ImageUploading value={team.userProfile} onChange={image => changeImageAboutHandler(image, team.id)} dataURLKey="data_url">
                    {({ imageList, onImageUpload, onImageRemove }) => (
                      <>
                        {imageList.length > 0 ? (
                          imageList.map((item, index) => (
                            <>
                              <img key={index} className={`mb-1 ${styles.about_uploaded_image}`} src={item["data_url"]} alt="about-uploaded-profile" />
                              <div className="pointer">
                                <img onClick={() => onImageRemove(index)} src={trashIcon} alt="icon" />
                              </div>
                            </>
                          ))
                        ) : (
                          <>
                            <img src={noProfileAboutIcon} alt="about-no_upload-img" />
                            <div className={`pt-3 d-flex align-items-center justify-content-center`} role="button" onClick={onImageUpload}>
                              <span className={`${styles.text_add_upload_icon_box}`}> افزودن عکس </span>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </ImageUploading>
                </div>

                <div className={`d-flex justify-content-between align-items-start flex-wrap me-4 ${styles.total_form_info_team_about_box}`}>
                  <Form.Group className={`${styles.total_form_group} d-flex flex-column`}>
                    <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="fullName">
                      {" "}
                      نام و نام خانوادگی{" "}
                    </Form.Label>
                    <Form.Control
                      className={`${styles.form_control_input} shadow-none`}
                      type="text"
                      id="fullName"
                      name="fullName"
                      value={team.fullName}
                      onChange={e => formAboutTeamChangeHandler(e, team.id)}
                    />
                  </Form.Group>
                  <Form.Group className={`${styles.total_form_group} d-flex flex-column`}>
                    <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="position">
                      {" "}
                      سمت{" "}
                    </Form.Label>
                    <Form.Control
                      className={`${styles.form_control_input} shadow-none`}
                      type="text"
                      id="position"
                      name="position"
                      value={team.position}
                      onChange={e => formAboutTeamChangeHandler(e, team.id)}
                    />
                  </Form.Group>
                </div>
              </div>
            ))}
          </div>

          <div className="py-2 mb-4">
            <div className="container-fluid">
              <div
                className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-3 me-3"}`}
                dir="rtl">
                <div className="w-100 d-flex align-items-center justify-content-md-end justify-content-center">
                  {btnLoader ? (
                    <div className={Dstyles.btn_loader_container}>
                      <div className={Dstyles.btn_spinner}></div>
                    </div>
                  ) : (
                    <button className={`${Dstyles.filled_blue} text-white border-0`} onClick={teamUsersHandler}>
                      {" "}
                      ثبت اطلاعات تیم{" "}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* <div className={"text-left pb-5"}>
                
            </div> */}
        </div>
      )}
    </>
  );

  function notify(text, type) {
    if (type === "success") {
      setBtnLoader(false);
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      setBtnLoader(false);
      toast.error(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }

  async function formSendHandler() {
    try {
      setBtnLoader(true);
      const image1 = images.image1 || formAboutValue.image1 != "" ? true : false;
      const image2 = images.image2 || formAboutValue.image2 != "" ? true : false;
      if (
        image1 &&
        image2 &&
        formAboutValue.title_1 !== "" &&
        formAboutValue.title_2 !== "" &&
        formAboutValue.content_1 !== "" &&
        formAboutValue.content_2 !== ""
      ) {
        notify("درحال اعمال تغییرات جدید", "success");
        var aboutText = new FormData();
        aboutText.append("Id", 1);
        aboutText.append("FirstTitle", formAboutValue.title_1);
        aboutText.append("FirstImageName", formAboutValue.image1 ? formAboutValue.image1 : images.image1[0].file);
        aboutText.append("SecondTitle", formAboutValue.title_2);
        aboutText.append("SecondImageName", formAboutValue.image2 ? formAboutValue.image2 : images.image2[0].file);
        aboutText.append("FirstDescription", formAboutValue.content_1);
        aboutText.append("SecondDescription", formAboutValue.content_2);
        const aboutusTexts = await axios.put("AboutUs/EditAboutUs", aboutText, {
          headers: { authorization: "Bearer " + userToken },
        });
        notify("عملیات با موفقیت انجام شد", "success");
        window.location.reload(false);
      } else {
        notify("لطفا تمام فیلد هارا پر کنید", "error");
      }
      setBtnLoader(false);
    } catch (error) {
      // console.log(error)
      notify("خطای سرور", "error");
    }
  }

  async function teamUsersHandler() {
    try {
      setBtnLoader2(true);
      notify("درحال اعمال تغییرات جدید", "success");
      if (formAboutValue.teams[0].fullName !== "") {
        for (const teamMember of formAboutValue.teams) {
          var aboutTeam = new FormData();
          aboutTeam.append("FullName", teamMember.fullName);
          aboutTeam.append("ImageFile", teamMember.userProfile[0].file);
          aboutTeam.append("Responsibility", teamMember.position);
          const aboutTeamMembers = await axios.post("AboutUs/AddTeamUser", aboutTeam, {
            headers: { authorization: "Bearer " + userToken },
          });
          // console.log(aboutTeamMembers)
        }
        notify("تغییرات با موفقیت اعمال شد", "success");
      } else {
        notify("لطفا تمام فیلد هارا پر کنید", "error");
      }
      setBtnLoader2(false);
    } catch (error) {
      notify("خطای سرور", "error");
    }
  }

  async function memberDeleteHandler(userId) {
    // console.log(userId?.toString())
    try {
      notify("درحال حذف", "success");
      var data = {
        id: userId?.toString(),
      };
      const apiData = await axios.delete("AboutUs/DeleteTeamUser", {
        headers: { authorization: "Bearer " + userToken },
        data: data,
      });
      // console.log(apiData)
      notify("فرد حذف شد", "success");
      window.location.reload(false);
    } catch (error) {
      notify("خطای سرور", "error");
      // console.log(error)
    }
  }
};

export default SettingAboutForm;
